export default "__VITE_ASSET__8e5bc53a__"